import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "_mb-2 _flex _ai-c"
}
const _hoisted_2 = ["alt", "src"]
const _hoisted_3 = { class: "_mt-0" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_tooltip = _resolveComponent("tooltip")

  return ($options.isLanguageSelectionInfoVisible)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        ($options.isLanguageFlagVisible)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              class: _normalizeClass(['gfu-icon gfu-icon--elevate _mr-1', { '_baw': !$options.isContentTranslated }]),
              width: "24",
              alt: $options.currentLanguageName,
              src: $options.currentLanguageFlagImage
            }, null, 10 /* CLASS, PROPS */, _hoisted_2))
          : (_openBlock(), _createBlock(_component_base_icon, {
              key: 1,
              class: "_tc--accent _mr-1",
              size: "lg",
              name: "language"
            })),
        _createElementVNode("p", _hoisted_3, [
          _createTextVNode(_toDisplayString($options.info) + " ", 1 /* TEXT */),
          ($options.hasTranslations)
            ? (_openBlock(), _createBlock(_component_tooltip, {
                key: 0,
                text: $options.tooltipText
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_base_icon, { name: "circle-info" })
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["text"]))
            : _createCommentVNode("v-if", true)
        ]),
        ($options.hasTranslations)
          ? (_openBlock(), _createElementBlock("button", {
              key: 2,
              class: "_pt-0 _pb-0 _tc--accent",
              onClick: _cache[0] || (_cache[0] = (...args) => ($options.changeLanguage && $options.changeLanguage(...args)))
            }, _toDisplayString(_ctx.Resources.ProjectHome.ChangeLanguageButton), 1 /* TEXT */))
          : _createCommentVNode("v-if", true)
      ]))
    : _createCommentVNode("v-if", true)
}